import { render, staticRenderFns } from "./NavSearchResultsProducts.vue?vue&type=template&id=78e44c15"
import script from "./NavSearchResultsProducts.vue?vue&type=script&lang=js"
export * from "./NavSearchResultsProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports